import {
  PerformanceScoreConfiguration,
  PerformanceTargetStrategy,
} from 'generated/resources/datatable.graphql'

export const events = {
  goToPerformanceReviews: 'Go to performance reviews',
  createReviewStarted: 'Create review started',
  createReviewSubmitted: 'Create review submitted',
  launchReview: 'Launch review',
  viewReview: 'View review',
  completeEvaluationStarted: 'Complete evaluation started',
  completeEvaluationSubmitted: 'Complete evaluation submitted',
}

export const targetStrategyToEvent = (
  targetStrategy?: PerformanceTargetStrategy | null
): string | undefined => {
  const strategy = targetStrategy?.strategy
  if (!strategy) return

  switch (strategy) {
    case 'all_employees':
      return 'whole_company'
    case 'by_teams':
    case 'by_locations':
      return 'dynamic_group'
    case 'by_employees':
    case 'manual_selection':
      return 'manual_selection'
    default:
      const _exhaustiveCheck: never = strategy
      return _exhaustiveCheck
  }
}

export const scoreConfigurationToEvent = (
  scoreConfiguration?: Pick<PerformanceScoreConfiguration, 'mode'> | null
): string => scoreConfiguration?.mode ?? 'without'
